import { apiLoad } from './apiLoad';
import { fallback } from './fallback';
import { load } from './load';
import { reload } from './reload';
import { set } from './set';
import { messages as messagesUtil } from 'utils';

// Clear all translation cache - useful for development or forcing refresh
function clearCache() {
  messagesUtil.clear();
}

// Force fresh load by clearing cache first
async function forceLoad(value: availableLocales) {
  clearCache();
  await load(value);
}

const messages = {
  load,
  reload,
  set,
  fallback,
  apiLoad,
  clearCache,
  forceLoad,
};

export { messages };
